import type { GridApi } from 'ag-grid-community';
import { useCallback } from 'react';

export const useResetFilter = (gridApi?: GridApi | null) => {
  return useCallback(
    (colId: string) => {
      gridApi?.setColumnFilterModel(colId, null);
      gridApi?.onFilterChanged('advancedFilter');
    },
    [gridApi],
  );
};
